import { useMemo } from 'react';
import siteConfig from '../config/site.json';
import appMainJson from '../assets/data/appMain.json';

/**
 * Hook for text replacement and template processing
 * @returns {Object} Object with replace and getText functions
 */
export const useTextReplacement = () => {
  // Create replace map from appMainJson
  const replaceMap = useMemo(() => {
    return {
      '{{COMPANY_NAME}}': appMainJson.CompanyName || 'Fleur Lamont Ltd',
      '{{APP_DISPLAY_NAME}}': appMainJson.DisplayName || 'ScaffolderJS',
      '{{APP_INTERNAL_NAME}}': appMainJson.InternalName || 'scaffolderjs',
      // Add more as needed
    };
  }, []);

  /**
   * Replace template placeholders in text
   * @param {string} text - Text with {{PLACEHOLDER}} placeholders
   * @returns {string} - Text with placeholders replaced
   */
  const replace = useMemo(() => {
    return (text) => {
      if (!text || typeof text !== 'string') return text;
      return text.replace(/\{\{(\w+)\}\}/g, (match) => {
        return replaceMap[match] || match;
      });
    };
  }, [replaceMap]);

  /**
   * Get text value from config
   * @param {string} key - Key to look up (supports {{PLACEHOLDER}} format)
   * @returns {string} - Text value or key if not found
   */
  const getText = useMemo(() => {
    return (key) => {
      // Try replace map first
      if (replaceMap[key]) {
        return replaceMap[key];
      }
      // Try site.json
      if (siteConfig[key]) {
        return siteConfig[key];
      }
      // Return key if not found
      return key;
    };
  }, [replaceMap]);

  return { replace, getText };
};

export default useTextReplacement;

